<template>
    <div>
        <!-- Start the code for this screen here -->
        <div class="container-fluid overflow-auto pb-4">
            <!-- Start the code for this screen here -->
            <div class="llp-container-section heightcontainer">
                <nav class="navbar navbar-expand-lg bg-info text-white">
                    <span><b>Contact Us</b></span>
                </nav>
                <div v-if="saved">
                    <p align="center" class="confirm-message">{{message}}</p>
                </div>
                <center>
                    <span>LUXURY LEASE PARTNERS IS AVAILABLE IN MOST STATES. CONTACT US FOR ADDITIONAL INFORMATION.</span>
                    <br />
                    <br />
                    <br />
                    <span>
                        Luxury Lease Partners LLC<br />
                        210 Summit Ave. Suite C4<br />
                        Montvale, N.J. 07645 &nbsp; &nbsp;Contact : (201) 822-4870
                    </span>
                </center>
                <br />
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm required">Name</label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type="text" v-validate="'required'" class="form-control input-sm" data-vv-name="Name" v-model="contactus.full_name" value="" maxlength="100" placeholder="First Name  Last Name" />
                        <div v-if="errors.has('Name')" class="alert-danger">{{ errors.first('Name') }}</div>
                    </div>
                    <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Phone</label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input
                            type="text"
                            v-model="contactus.phone_number"
                            class="form-control input-sm"
                            pattern="[0-9]*"
                            v-validate="'min:10|max:14'"
                            maxlength="10"
                            @input="formatCellPhoneNumber"
                            @blur="formatCellPhoneNumber"
                            placeholder="+1(XXX) XXX XXXX"
                        />
                    </div>

                    <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">E-Mail</label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type="text" v-model="contactus.email" class="form-control input-sm" maxlength="100" placeholder="example@domain.com" />
                    </div>
                </div>
                <br />
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Preferred Contact</label>
                    </div>

                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-for="data in items">
                        <input type="checkbox" v-model="contactus.preferredContact" v-bind:value="data" @change="updateCheckall()" /> {{data}}
                    </div>
                    <div class="col justify-content-end align-items-center"><input type="checkbox" class="pr-2" @click="checkAll()" v-model="contactus.isCheckAll" /> Both</div>
                </div>
                <br />
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Message</label>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <textarea v-model="contactus.schedule_notes" rows="10" class="form-control input-sm" placeholder="Message"></textarea>
                    </div>
                </div>

                     <div class="center mb-2">

                        <button type="submit" @click="addContact()" class="btn btn-secondary  mr-2">Submit</button>
                         <button type="submit" class="btn btn-secondary  mr-2" @click="resetdata">Reset</button>
                        <router-link to="/" tag="a" class="btn btn-secondary">Back</router-link></div>

            </div>
        </div>

        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
    </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcontactus from '../js/http-contactus'
export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      saved: false,
      contactus: this.createEmptyCustomerObject(),
      message: '',
      items: ['Email', 'Phone']
    }
  },
  methods: {
    resetdata () {
      this.contactus = this.createEmptyCustomerObject()
      this.message = ''
    },
    check: function (e) {
      if (e.target.checked) {
        console.log(e.target.value)
      }
    },

    checkAll: function () {
      this.contactus.isCheckAll = !this.contactus.isCheckAll
      this.contactus.preferredContact = []
      if (this.contactus.isCheckAll) {
        // Check all
        for (var key in this.items) {
          this.contactus.preferredContact.push(this.items[key])
        }
      }
    },
    updateCheckall: function () {
      if (this.contactus.preferredContact.length == this.items.length) {
        this.contactus.isCheckAll = true
      } else {
        this.contactus.isCheckAll = false
      }
    },
    createEmptyCustomerObject () {
      return {
        full_name: '',
        phone_number: '',
        email: '',
        Notes: '',
        isCheckAll: false,
        preferredContact: []
      }
    },

    addContact (e) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let newContact = {
            fullName: this.contactus.full_name,
            phoneNumber: this.contactus.phone_number,
            email: this.contactus.email,
            preferredContact: this.contactus.preferredContact.toString(),
            scheduleNotes: this.contactus.schedule_notes
          }
          httpcontactus.post('/savecontact/', newContact).then((response) => {
            var status = response.data
            console.log('Successfully saved:' + JSON.stringify(status))
            if (status == 'CREATED') {
              this.saved = true
              this.message = 'CONTACT Successfully added into the system'
              this.contactus = this.createEmptyCustomerObject()
              this.errors.clear()
              this.$validator.reset()
            } else {
              this.message = ''
            }
          })
        }
      })
    },
    formatCellPhoneNumber: function (event) {
      var phone = this.contactus.phone_number
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.contactus.phone_number = phone
    }
  }
}
</script>
<style scoped></style>
